import { css } from '@emotion/react';

const styles = css`
  margin: 0;
  outline: none;
  list-style: none;
  box-sizing: content-box;
  padding: 0 var(--cds-spacing-25);

  /* Ensure padding applies when rendered as <ul> inside Popover Body */
  ul&& {
    padding: 0 var(--cds-spacing-25);
  }

  li + li {
    margin-top: var(--cds-spacing-25);
  }
`;

export default styles;
